module.exports = __webpack_public_path__ + "img/airplanemode_active_white.fb379a52.svg";